export const SET_IS_APPLY_MODAL_ACTIVE = "SET_IS_APPLY_MODAL_ACTIVE";
export const SET_JOB_ID = "SET_JOB_ID";
export const RESET_ALL_STATES = "RESET_ALL_STATES";
export const SET_JOB_APPLICATION = "SET_JOB_APPLICATION";
export const SET_JOB_PAYLOAD = "SET_JOB_PAYLOAD";
export const SET_IS_ORGANIZATION_ADMIN = "SET_IS_ORGANIZATION_ADMIN";
export const SET_IS_JOB_SAVED = "SET_IS_JOB_SAVED";
